import { createSlice } from '@reduxjs/toolkit';
import { RootState, useCreateUseState } from '@hooks/redux/redux';
import { store } from '@/store';
import { CommonSettings } from '@/services/api/settingsApiArea/types';
import { commonSettingsApiArea } from '@/services/api/settingsApiArea';

export interface IEventsFilters {
  name: string;
  module: string;
}

export const DEFAULT_MODULE_ID = '0';

// Локальные ключи для localStorage
export const LOCAL_STORE = {
  events: 'events',
  filters: 'filters'
} as const;

// Получение данных из localStorage
const getLocalStorageData = <T>(key: string, value?: T) => {
  const data = window.localStorage.getItem(key);
  return data ? JSON.parse(data) : value;
};

// Структура общего состояния
interface State {
  isLoading: boolean;
  events: CommonSettings | undefined;
  filters: IEventsFilters;
}

const initialState: State = {
  isLoading: true,
  events: getLocalStorageData(LOCAL_STORE.events, []),
  filters: getLocalStorageData(LOCAL_STORE.filters, {
    name: '',
    module: DEFAULT_MODULE_ID
  })
};

const eventsTrail = createSlice({
  name: 'eventsTrail',
  initialState,
  reducers: {
    setIsLoading(state: any, action) {
      state.isLoading = action.payload;
    },
    setEvents(state: any, action) {
      state.events = action.payload;
    },
    setFilters(state: any, action) {
      state.filters = action.payload;
    }
  }
});
const { setEvents, setFilters, setIsLoading } = eventsTrail.actions;

const LoadEvents = async () => {
  commonSettingsApiArea()
    .GetSettings()
    .then((data) => store.dispatch(setEvents(data)))
    .finally(() => store.dispatch(setIsLoading(false)));
};

const LoadEventsWithOutLoadingStatus = async () => {
  commonSettingsApiArea()
    .GetSettings()
    .then((data) => store.dispatch(setEvents(data)));
};

const actions = {
  ...eventsTrail.actions,
  LoadEventsWithOutLoadingStatus,
  LoadEvents
};

const useEventsTrailSlice = () => {
  return {
    actions,
    useIsLoading: () =>
      useCreateUseState<boolean>(
        (state: RootState) => state.eventsTrail.isLoading,
        (isLoading) => setIsLoading(isLoading)
      ),
    useEvents: () =>
      useCreateUseState<CommonSettings | undefined>(
        (state: RootState) => state.eventsTrail.events,
        (events) => setEvents(events),
        LOCAL_STORE.events
      ),
    useFilters: () =>
      useCreateUseState<IEventsFilters>(
        (state: RootState) => state.eventsTrail.filters,
        (filters) => setFilters(filters),
        LOCAL_STORE.filters
      )
  };
};

export const eventsTrailReducer = eventsTrail.reducer;

export default useEventsTrailSlice;
